/*
 * @Author: huangzeshen
 * @Date: 2024-03-29 20:09:12
 * @LastEditors: huangzeshen
 * @LastEditTime: 2024-03-30 11:50:32
 * @FilePath: /waton-mobile/src/i18n/locals/zh-HK/index.js
 * @Description: 
 */
import user from './user';
import asset from './asset';
import stock from './stock';
import info from './info';
import openAccount from './openAccount';

const language = {
    ...user,
    ...asset,
    ...stock,
    ...info,
    ...openAccount,
};

export default language;